import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=1d0d62a0&scoped=true&"
import script from "./Trend.vue?vue&type=script&lang=js&"
export * from "./Trend.vue?vue&type=script&lang=js&"
import style0 from "./Trend.vue?vue&type=style&index=0&id=1d0d62a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d62a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
